import * as React from "react";
import { gql, useMutation, ApolloError } from "@apollo/client";
import {
  ForgotPasswordChangeAdminMutationMutation,
  ForgotPasswordChangeAdminMutationMutationVariables
} from "../../../../schemaTypes";
import { normalizeErrors } from "../../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../../types/NormalizedErrorMap";

const forgotPasswordChangeAdminMutation = gql`
  mutation ForgotPasswordChangeAdminMutation(
    $newPassword: String!,
    $confirmNewPassword: String!,
    $key: String!
  ) {
    forgotPasswordChangeAdmin(
      newPassword: $newPassword, 
      confirmNewPassword: $confirmNewPassword,
      key: $key
    ) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface ChangePasswordAdminControllerProps {
  children: (
    data: {
      submit: (
        values: ForgotPasswordChangeAdminMutationMutationVariables
      ) => Promise<NormalizedErrorMap | null>;
      loading: boolean;
      error?: ApolloError;
      message?: string | null;
    }
  ) => React.ReactElement | null;
}

export const ChangePasswordAdminController: React.FC<ChangePasswordAdminControllerProps> = ({ children }) => {
  const [_forgotPasswordChangeAdminMutation, { loading, error }] = useMutation<
    ForgotPasswordChangeAdminMutationMutation,
    ForgotPasswordChangeAdminMutationMutationVariables
  >(forgotPasswordChangeAdminMutation);

  const [message, setMessage] = React.useState<string | null>(null);

  const submit = async (values: ForgotPasswordChangeAdminMutationMutationVariables) => {
    const { data } = await _forgotPasswordChangeAdminMutation({ variables: values });
    if (data?.forgotPasswordChangeAdmin) {
      setMessage(data.forgotPasswordChangeAdmin.message ?? null);
      return normalizeErrors((data.forgotPasswordChangeAdmin.errors || []).filter((e): e is Exclude<typeof e, null> => e !== null));
    }
    setMessage(null);
    return null;
  };

  return children({ submit, loading, error, message });
};